import UserImage from "../../UserImage";
import taskModalStyles from "./EditTaskModal.module.scss";
import { formatDate } from "../../../utils/dbUtils";
import { AppContext } from "../../../AppContext";
import { useContext } from "react";

export const CommentBox = ({ comment, onEdit, onDelete }) => {
  const { user } = useContext(AppContext);

  return (
    <div className={taskModalStyles.comment_container}>
      <div style={{ flexShrink: "0" }}>
        <UserImage targetUser={comment.user} />
      </div>
      <div className={taskModalStyles.comment_div}>
        <div className={taskModalStyles.comment_header}>
          <span className={taskModalStyles.comment_author}>
            {comment.user.first_name + " " + comment.user.last_name}
          </span>
          <span className={taskModalStyles.comment_date}>
            {formatDate(comment.created_at)}
          </span>
        </div>
        <article className={taskModalStyles.comment_text}>
          {comment.content}
        </article>
        {user.id === comment.user.id && (
          <div className={taskModalStyles.small_text}>
            <button onClick={onEdit} className={taskModalStyles.comment_btn}>
              Modifica
            </button>{" "}
            |{" "}
            <button onClick={onDelete} className={taskModalStyles.comment_btn}>
              Elimina
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
